import { useEffect } from 'react'
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { registerPlatformReportDownloadHandler } from '@/utils/platformReport'
import { logoutPlatform } from '@/api/platformApi'
import { clearPlatformToken } from '@/utils/platformAdminAuth'
import {
  getPlatformBasePath,
  getPlatformDashboardPath,
  getPlatformLoginPath,
  getPlatformNovaTenantPath,
  getPlatformTenantsPath,
  PLATFORM_ROOT_CLASS,
} from '@/config/platform'
import { PlatformThemeToggle } from '@/pages/Platform/PlatformThemeToggle'
import './platformTheme.css'
import { useSaveFeedback } from '@/hooks/useSaveFeedback'
import styles from './Platform.module.css'

function navClass(isActive: boolean) {
  return `${styles.sidebarLink} ${isActive ? styles.sidebarLinkActive : ''}`.trim()
}

function isContasSection(pathname: string): boolean {
  const base = getPlatformBasePath()
  if (pathname === `${base}/tenants`) return true
  if (pathname === `${base}/tenants/novo`) return false
  return new RegExp(`^${base.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}/tenants/\\d+$`).test(pathname)
}

export function PlatformLayout() {
  const navigate = useNavigate()
  const location = useLocation()
  const { notifyInfo } = useSaveFeedback()

  useEffect(() => {
    registerPlatformReportDownloadHandler()
  }, [])

  const sair = async () => {
    await logoutPlatform()
    clearPlatformToken()
    notifyInfo('Sessão da plataforma terminada.')
    navigate(getPlatformLoginPath(), { replace: true })
  }

  return (
    <div className={`${PLATFORM_ROOT_CLASS} ${styles.platformShell}`}>
    <div className={styles.shell}>
      <aside className={styles.sidebar} aria-label="Navegação da plataforma">
        <div className={styles.sidebarBrand}>Operação · SaaS</div>
        <p className={styles.sidebarTag}>Painel interno</p>
        <nav className={styles.sidebarNav}>
          <NavLink to={getPlatformDashboardPath()} end className={({ isActive }) => navClass(isActive)}>
            <span className={styles.sidebarIcon} aria-hidden>
              ◎
            </span>
            Visão geral
          </NavLink>
          <NavLink
            to={getPlatformTenantsPath()}
            end
            className={({ isActive }) => navClass(isActive || isContasSection(location.pathname))}
          >
            <span className={styles.sidebarIcon} aria-hidden>
              ☰
            </span>
            Contas
          </NavLink>
          <NavLink to={getPlatformNovaTenantPath()} className={({ isActive }) => navClass(isActive)}>
            <span className={styles.sidebarIcon} aria-hidden>
              +
            </span>
            Nova conta
          </NavLink>
        </nav>
        <div className={styles.sidebarFooter}>
          <PlatformThemeToggle compact />
          <button type="button" className={styles.sidebarLogout} onClick={sair}>
            Sair
          </button>
        </div>
      </aside>
      <div className={styles.content}>
        <main className={styles.main}>
          <Outlet />
        </main>
      </div>
    </div>
    </div>
  )
}
